'use es6';

import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useGroupIndices } from '../SourceMeta';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CloneFilterSelect = ({
  currentGroupId,
  onCloneFilter,
  disabled = false,
  tooltipMessage
}) => {
  const groupIndices = useGroupIndices();
  return onCloneFilter && currentGroupId != null ? /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: tooltipMessage,
      children: /*#__PURE__*/_jsx(Dropdown, {
        disabled: disabled,
        buttonSize: "xs",
        buttonText: I18n.text('reporting-snowflake.filter-editor.editor-panel.clone-button'),
        children: /*#__PURE__*/_jsxs(List, {
          wrapChildren: true,
          children: [groupIndices.toArray().filter(groupIndex => groupIndex !== undefined && currentGroupId !== groupIndex).map(groupIndex => /*#__PURE__*/_jsx(Button, {
            onClick: () => onCloneFilter(groupIndex),
            children: I18n.text('reporting-snowflake.filter-editor.editor-panel.clone-option', {
              groupId: String(groupIndex + 1)
            })
          }, groupIndex)), /*#__PURE__*/_jsx(Button, {
            onClick: () => onCloneFilter(),
            children: I18n.text('reporting-snowflake.filter-editor.editor-panel.clone-new-group-option')
          }, "new")]
        })
      })
    })
  }) : null;
};